export default {
    england: {
        armycol: '#00008b',
        countrycol: '#6185dd',
        originalsites: ['Lon','Liv','Edi'],
    },
    france: {
        armycol: '#5f9ea0',
        countrycol: '#add8e6',
        originalsites: ['Par','Bre','Mar'],
    },
    germany: {
        armycol: '#000000',
        countrycol: '#777777',
        originalsites: ['Ber','Kie','Mun'],
    },
    austria:{
        armycol: '#FF0000',
        countrycol: '#f08080',
        originalsites: ['Vie','Bud','Tri'],
    },
    italy:{
        armycol: '#008000',
        countrycol: '#90ee90',
        originalsites: ['Rom','Ven','Nap'],
    },
    rusia:{
        armycol: '#AAAAAA',
        countrycol: '#FFFFFF',
        originalsites: ['Mos','War','Stp','Sev'],
    },
    turkey:{
        armycol: '#ffc813',
        countrycol: '#ffff7c',
        originalsites: ['Con','Ank','Smy'],
    }
}